export const useUtils = () => {
    const nl2br = (text: string): string => text.replace(/(\r\n|\r|\n)/g, "<br>");

    const toCurrency = (
        number: number = 0,
        currency: string = "EUR",
        locale: string = currency === "EUR" ? "fr-FR" : "en-AU",
    ): string =>
        new Intl.NumberFormat(locale, {
            style: "currency",
            currency,
            currencyDisplay: "symbol",
        }).format(number);

    const filesize = (size: number): string => {
        const i = Math.floor(Math.log(size) / Math.log(1024));
        return `${(size / Math.pow(1024, i)).toFixed(2)} ${["B", "Kb", "Mb", "Gb", "Tb"][i]}`;
    };

    const removeEmpty = (obj: Record<string, any>): Record<string, any> => {
        return Object.fromEntries(
            Object.entries(obj)
                .map(([key, value]) => (value && typeof value === "object" ? [key, removeEmpty(value)] : [key, value]))
                .filter(
                    //eslint-disable-next-line no-unused-vars
                    ([_, value]) =>
                        value !== "" &&
                        value !== undefined &&
                        value !== null &&
                        (typeof value !== "object" || Object.keys(value).length),
                ),
        );
    };

    return { nl2br, toCurrency, filesize, removeEmpty };
};
